import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="relative z-10 min-h-screen flex items-center justify-center px-5">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} className="border border-[#5A2A24] bg-[#2C0D12] p-10 md:p-16 max-w-lg w-full text-center">
        <XCircle className="w-14 h-14 text-[#C0894F] mx-auto mb-6" />
        <h1 className="font-display uppercase text-4xl mb-2">Cancelled</h1>
        <p className="text-[#C7A98F] mb-8">Your deposit was cancelled. The piece is still available.</p>
        <Link to="/marketplace" className="btn-tactical">Back to Marketplace</Link>
      </motion.div>
    </div>
  );
}
